import React from 'react';
import { TableCell, TableSortLabel } from '@mui/material';

/**
 * Thin wrapper around MUI's `TableSortLabel` so each admin tab can wire
 * a sortable column with two props (`field`, `label`) instead of
 * threading `active` + `direction` + `onClick` by hand.
 *
 *   <SortableHeader field='email' sortBy={sortBy} sortDir={sortDir} onSort={setSort}>
 *     Email
 *   </SortableHeader>
 */
export default function SortableHeader({ field, sortBy, sortDir, onSort, children, align }) {
  const active = sortBy === field;
  const direction = active ? sortDir : 'asc';
  const flip = () => {
    if (!active) return onSort({ sort_by: field, sort_dir: 'asc' });
    if (sortDir === 'asc') return onSort({ sort_by: field, sort_dir: 'desc' });
    // Third click clears the explicit sort so we fall back to the
    // server's default order (recency).
    onSort({ sort_by: null, sort_dir: null });
  };
  return (
    <TableCell align={align} sortDirection={active ? direction : false}>
      <TableSortLabel active={active} direction={direction} onClick={flip}>
        {children}
      </TableSortLabel>
    </TableCell>
  );
}
